/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type CreateContractProposalPensionSavingBodyInvestmentToolType =
  (typeof CreateContractProposalPensionSavingBodyInvestmentToolType)[keyof typeof CreateContractProposalPensionSavingBodyInvestmentToolType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateContractProposalPensionSavingBodyInvestmentToolType = {
  pension_saving: "pension_saving",
} as const;
